import React, {FC} from "react";
import styled from "styled-components";
import { ProfileBeaconButton } from './ProfileBeaconComponents';
import { ReactComponent as EditIcon } from 'assets/editIcon.svg';

interface Props {
    buttonTitle?: string;
    imageUrl?: string;
    linkTitle?: string;
    altText?: string;
    disabled?: boolean;
    onBeaconClick?: () => void;
    onClick?: () => void;
    isLink?: boolean;
    isIcon?: boolean;
}

const StyledBeaconButton = styled(ProfileBeaconButton)`
  @media only screen and (max-width: 640px) {
    width: 100%;
  }
`;

const StyledTertiaryBeaconButton = styled(ProfileBeaconButton)`
  --beacon-button-space-padding-block-start-normal: 0;
  --beacon-button-space-padding-block-end-normal: 0;
  @media only screen and (max-width: 640px) {
    width: auto;
  }
`;

const StyledSignUpBeaconButton  = styled(ProfileBeaconButton)`
  --beacon-button-font-size-normal :18px;
  --beacon-button-space-padding-block-start-normal: 0;
  --beacon-button-space-padding-block-end-normal: 0;
  @media only screen and (max-width: 768px) {
    width: auto;
    --beacon-button-font-size-normal :16px;
  }
`;

const Button: FC<Props> = ({
                               buttonTitle,
                               disabled=false,
                               isIcon,
                               onBeaconClick,
                               variant="primary",
                               altText
                           }) => {
    return (
        <>
            {variant === "tertiary" ?
                <StyledTertiaryBeaconButton variant={variant} scale="small" label={buttonTitle} disabled={disabled}
                                    onBeaconClick={onBeaconClick}>
                    {isIcon && <EditIcon/>}
                </StyledTertiaryBeaconButton>
                :
                variant === "signUp" ?
                    <StyledSignUpBeaconButton variant={"tertiary"} scale="small" label={buttonTitle} disabled={disabled}
                                              onBeaconClick={onBeaconClick}>
                        {isIcon && <EditIcon/>}
                    </StyledSignUpBeaconButton>
                    :
                <StyledBeaconButton variant={variant} scale="small" label={buttonTitle} disabled={disabled}
                                    onBeaconClick={onBeaconClick}>
                </StyledBeaconButton>
            }
        </>
    );
}
export default Button;